export interface Slot {
  start: Date;
  end: Date;
}

export function intersectSlots(slotsA: Slot[], slotsB: Slot[], minDuration: number): Slot[] {
  return [];
}

export function pickTopSlots(slots: Slot[], count: number): Slot[] {
  return [];
}






